import React from 'react'
import propTypes from 'prop-types'
import classnames from 'classnames'

import TextWithIcon from 'views/components/molecules/TextWithIcon'

import withDataQA from 'views/enhancers/withDataQA'

const LinkWithIcon = props => (
  <a
    href={props.href}
    target={props.target === '_blank' ? props.target : null}
    rel={props.target === '_blank' ? 'noopener noreferrer' : null}
    className={classnames('a-link--underline', props.className)}
  >
    <TextWithIcon
      icon={props.icon}
      iconSize={props.iconSize}
      iconColor={props.iconColor}
      centered={props.centered}
      inline={props.inline}
      right={props.right}
    >
      {props.children}
    </TextWithIcon>
  </a>
)

LinkWithIcon.propTypes = {
  icon: propTypes.string,
  iconSize: propTypes.string,
  iconColor: propTypes.string,
  centered: propTypes.bool,
  inline: propTypes.bool,
  right: propTypes.bool,
  href: propTypes.string.isRequired,
  children: propTypes.node.isRequired,
  target: propTypes.string,
  className: propTypes.string
}

LinkWithIcon.defaultProps = {
  icon: null,
  iconSize: null,
  iconColor: null,
  centered: false,
  inline: false,
  right: false,
  target: null,
  className: null
}

export default withDataQA(LinkWithIcon)
